var React = require('react');

function Rss (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":1}),React.createElement("path",{"d":"M26,23H23.39A12.39,12.39,0,0,0,11,10.61V8A15,15,0,0,1,26,23Z","key":2}),React.createElement("path",{"d":"M20.78,23H18.17A7.17,7.17,0,0,0,11,15.83V13.22A9.78,9.78,0,0,1,20.78,23Z","key":3}),React.createElement("circle",{"cx":"12.96","cy":"21.04","r":"1.96","key":4})]);
}

Rss.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Rss;

Rss.default = Rss;
